import Vuex from "vuex"
import Vue from 'vue'
import NavTabs from './navTabs'
import Badge from './badge'

Vue.use(Vuex)
    //引入多个store
export default new Vuex.Store({
    state: {
        accountInfo: null,
        msgList: [],
    },
    getters: {
        user_id: state => {
            if (state.accountInfo == null)
                throw "请在获取用户信息之后使用该属性";
            return state.accountInfo.user_id;
        },
        emp_id: state => {
            if (state.accountInfo == null)
                throw "请在获取用户信息之后使用该属性";
            return state.accountInfo.emp_id;
        },
        main_dept_id: state => {
            if (state.accountInfo == null)
                throw "请在获取用户信息之后使用该属性";
            return state.accountInfo.main_dept.dept_id;
        },
        c_id: state => {
            if (state.accountInfo == null)
                throw "请在获取用户信息之后使用该属性";
            return state.accountInfo.company.c_id;
        },
        isDeveloper: state => {
            if (state.accountInfo == null) {
                throw { message: "请在获取用户信息后使用该方法" };
            }
            var roleinfos = state.accountInfo.roleinfos;
            if (!roleinfos) return false;
            for (let i = 0; i < roleinfos.length; i++) {
                const role = roleinfos[i];
                if (role.is_sys_role && (role.role_sys_code == "developer")) {
                    return true;
                }
            }
            return false;
        },
        isAdmin: state => {
            if (state.accountInfo == null) {
                throw { message: "请在获取用户信息后使用该方法" };
            }
            var roleinfos = state.accountInfo.roleinfos;
            if (!roleinfos) return false;
            for (let i = 0; i < roleinfos.length; i++) {
                const role = roleinfos[i];
                if (role.is_sys_role && (role.role_sys_code == "admin")) {
                    return true;
                }
            }
            return false;
        }
    },
    mutations: {
        setAccountInfo(state, value) {
            state.accountInfo = value;
        },
        addMsg(state, msg) {
            var arr = state.msgList.filter(s => s.msg_id == msg.msg_id);
            if (arr.length > 0) return;
            state.msgList.push(msg);
        },
        reloadMsg(state, msgs) {
            state.msgList = [];
            msgs.forEach(element => {
                state.msgList.push(element);
            });
        },
        setMsg(state, msgs) {
            state.msgList = msgs;
        },
        setCompany(state, c) {
            state.accountInfo.company = c;
            var account = JSON.parse(window.localStorage.getItem("AccountInfo"));
            account.company = c;
            window.localStorage.setItem("AccountInfo", JSON.stringify(account));
        }
    },
    modules: {
        navTabs: NavTabs,
        badge: Badge
    }
})